import { render, staticRenderFns } from "./AdLibraryBrandView.vue?vue&type=template&id=48799432&scoped=true"
import script from "./AdLibraryBrandView.vue?vue&type=script&lang=js"
export * from "./AdLibraryBrandView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48799432",
  null
  
)

export default component.exports